/* Animal Based – Warenkorbeinschub: "+"-Button der Empfehlungen legt das Produkt direkt in den Warenkorb
   und laesst den Einschub ueber den Theme-Mechanismus (pubsub cartUpdate) neu rendern. */

/* "−" bei Mindestmenge entfernt den Artikel (sonst blockiert die Theme-Validierung den Klick) */
if (!window.abCartMinusBound) {
  window.abCartMinusBound = true;
  document.addEventListener('click', (event) => {
    const button = event.target.closest('#CartDrawer .ab-qty__btn[name="minus"]');
    if (!button) return;

    const input = button.parentElement.querySelector('.ab-qty__input');
    const cartItems = button.closest('cart-items');
    if (!input || !cartItems || typeof cartItems.updateQuantity !== 'function') return;

    const minQty = Math.max(parseInt(input.getAttribute('data-min'), 10) || 1, 1);
    if (parseInt(input.value, 10) > minQty) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    cartItems.updateQuantity(input.getAttribute('data-index'), 0);
  }, true);
}
if (!customElements.get('ab-upsell-add')) {
  customElements.define(
    'ab-upsell-add',
    class AbUpsellAdd extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('button');
        if (!this.button || this.button.dataset.abBound) return;
        this.button.dataset.abBound = 'true';
        this.button.addEventListener('click', this.onClick.bind(this));
      }

      async onClick(event) {
        event.preventDefault();
        if (this.button.getAttribute('aria-busy') === 'true') return;

        const variantId = Number(this.dataset.variantId);
        if (!variantId) return;

        const hasTheme = window.theme && theme.routes && theme.utils && theme.pubsub;
        if (!hasTheme) {
          window.location.href = `/cart/add?id=${variantId}&quantity=1`;
          return;
        }

        this.button.setAttribute('aria-busy', 'true');
        this.classList.remove('is-error');

        const sections = [];
        document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections', { bubbles: true, detail: { sections } }));

        try {
          const addResponse = await fetch(theme.routes.cart_add_url, {
            ...theme.utils.fetchConfig('json'),
            body: JSON.stringify({
              items: [{ id: variantId, quantity: 1 }],
              sections,
              sections_url: window.location.pathname
            })
          });
          const parsed = await addResponse.json();

          if (parsed.status) {
            this.classList.add('is-error');
            this.button.setAttribute('title', parsed.description || parsed.message || '');
            return;
          }

          const cart = await (await fetch(theme.routes.cart_url, { ...theme.utils.fetchConfig('json', 'GET') })).json();
          cart.sections = parsed.sections;

          theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, {
            source: 'product-form',
            productVariantId: String(variantId),
            cart
          });
        }
        catch (error) {
          console.error(error);
          this.classList.add('is-error');
        }
        finally {
          if (this.isConnected) this.button.removeAttribute('aria-busy');
        }
      }
    }
  );
}

/* Geschenk-Stufen: Produkt automatisch hinzufuegen, sobald die Stufe erreicht ist, und wieder entfernen,
   wenn der Warenwert darunter faellt. Zustand kommt aus snippets/ab-cart-progress.liquid. */
(() => {
  if (window.abGiftSyncBound) return;
  window.abGiftSyncBound = true;

  let busy = false;
  let timer = null;
  let lastSignature = '';

  const readState = () => {
    const node = document.querySelector('#CartDrawer [data-ab-gifts]');
    if (!node) return null;
    try {
      return JSON.parse(node.textContent || '[]');
    }
    catch (error) {
      return null;
    }
  };

  const bundledSections = () => {
    const sections = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections', { bubbles: true, detail: { sections } }));
    return sections;
  };

  const publish = async (parsed, source) => {
    if (!(window.theme && theme.pubsub)) return;
    let cart = parsed;
    if (typeof parsed.item_count === 'undefined') {
      cart = await (await fetch(theme.routes.cart_url, { ...theme.utils.fetchConfig('json', 'GET') })).json();
      cart.sections = parsed.sections;
    }
    theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source, cart });
  };

  const sync = async () => {
    if (busy || !(window.theme && theme.routes && theme.utils)) return;
    const state = readState();
    if (!state || state.length === 0) return;

    const signature = JSON.stringify(state);
    if (signature === lastSignature) return;
    lastSignature = signature;

    // Echte Stufen haben Vorrang vor "verwaisten" Geschenkzeilen derselben Variante
    const managed = new Set(state.filter((g) => !g.orphan).map((g) => g.variant));
    const todo = state.filter((g) => !(g.orphan && managed.has(g.variant)));

    for (const gift of todo) {
      let request = null;
      if (gift.reached && !gift.line) {
        request = {
          url: theme.routes.cart_add_url,
          body: { items: [{ id: gift.variant, quantity: 1, properties: { _ab_gift: '1' } }] },
          source: 'product-form'
        };
      }
      else if (!gift.reached && gift.line) {
        request = { url: theme.routes.cart_change_url, body: { id: gift.line, quantity: 0 }, source: 'cart-items' };
      }
      else if (gift.reached && gift.line && gift.qty > 1) {
        request = { url: theme.routes.cart_change_url, body: { id: gift.line, quantity: 1 }, source: 'cart-items' };
      }
      if (!request) continue;

      busy = true;
      try {
        const response = await fetch(request.url, {
          ...theme.utils.fetchConfig('json'),
          body: JSON.stringify({ ...request.body, sections: bundledSections(), sections_url: window.location.pathname })
        });
        const parsed = await response.json();
        if (!parsed.status) await publish(parsed, request.source);
      }
      catch (error) {
        console.error(error);
      }
      finally {
        busy = false;
      }
      return; // nach jeder Aenderung neu rendern lassen und dann erneut pruefen
    }
  };

  const schedule = () => {
    clearTimeout(timer);
    timer = setTimeout(sync, 350);
  };

  const start = () => {
    const drawer = document.getElementById('CartDrawer');
    if (!drawer) return;
    new MutationObserver(schedule).observe(drawer, { childList: true, subtree: true });
    schedule();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  }
  else {
    start();
  }
})();